(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.closest('.cart-item__quantity').querySelector('.qty-input');
        let val = parseInt(input.value, 10) || 0;
        if (btn.dataset.action === 'plus') val++;
        if (btn.dataset.action === 'minus' && val > 0) val--;
        input.value = val;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var slider = document.querySelector('.hero-slider');
    if (!slider) return;

    var slides     = Array.from(slider.querySelectorAll('.hero__slide'));
    var dots       = Array.from(slider.querySelectorAll('.hero__dot'));
    var prevBtn    = slider.querySelector('.hero__arrow--prev');
    var nextBtn    = slider.querySelector('.hero__arrow--next');
    var autoplay   = slider.dataset.autoplay === 'true';
    var speed      = parseInt(slider.dataset.autoplaySpeed, 10) || 5000;
    var total      = parseInt(slider.dataset.slideCount, 10) || slides.length;
    var current    = 0;
    var timer      = null;

    function goTo(index) {
      index = ((index % total) + total) % total;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      current = index;
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    function start() {
      if (!autoplay || total <= 1) return;
      timer = setInterval(function () { goTo(current + 1); }, speed);
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    function restart() {
      stop();
      start();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); restart(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
        restart();
      });
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusout', start);

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { goTo(current - 1); restart(); }
      if (e.key === 'ArrowRight') { goTo(current + 1); restart(); }
    });

    var touchStartX = 0;
    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        goTo(current + (diff > 0 ? 1 : -1));
        restart();
      }
    });

    // Theme editor: jump to selected block
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest('.hero__slide');
      if (!slide) return;
      var idx = slides.indexOf(slide);
      if (idx !== -1) { stop(); goTo(idx); }
    });
    document.addEventListener('shopify:block:deselect', start);

    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-detail"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const galleryModal = document.querySelector('[data-gallery-modal]');
    const galleryImage = document.querySelector('[data-gallery-image]');
    const galleryThumbnails = document.querySelectorAll('.service-detail__thumbnail');
    const galleryClose = document.querySelector('[data-gallery-close]');
    const galleryPrev = document.querySelector('[data-gallery-prev]');
    const galleryNext = document.querySelector('[data-gallery-next]');

    let currentImageIndex = 0;
    const galleryImages = [];

    // Collect gallery images
    galleryThumbnails.forEach((thumb, idx) => {
      galleryImages.push({
        src: thumb.dataset.full || thumb.src,
        alt: thumb.alt
      });

      // Open gallery on thumbnail click
      thumb.addEventListener('click', () => {
        if (galleryModal) {
          currentImageIndex = idx;
          updateGalleryImage();
          galleryModal.removeAttribute('hidden');
          document.body.style.overflow = 'hidden';
        }
      });
    });

    function updateGalleryImage() {
      if (galleryImage && galleryImages[currentImageIndex]) {
        galleryImage.src = galleryImages[currentImageIndex].src;
        galleryImage.alt = galleryImages[currentImageIndex].alt;
      }
    }

    // Navigation
    if (galleryPrev) {
      galleryPrev.addEventListener('click', () => {
        currentImageIndex = (currentImageIndex - 1 + galleryImages.length) % galleryImages.length;
        updateGalleryImage();
      });
    }

    if (galleryNext) {
      galleryNext.addEventListener('click', () => {
        currentImageIndex = (currentImageIndex + 1) % galleryImages.length;
        updateGalleryImage();
      });
    }

    // Close gallery
    const closeGallery = () => {
      if (galleryModal) {
        galleryModal.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
    };

    if (galleryClose) {
      galleryClose.addEventListener('click', closeGallery);
    }

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && galleryModal && !galleryModal.hasAttribute('hidden')) {
        closeGallery();
      }
    });

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (galleryModal && !galleryModal.hasAttribute('hidden')) {
        if (e.key === 'ArrowLeft') galleryPrev?.click();
        if (e.key === 'ArrowRight') galleryNext?.click();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
